<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="toc"><a id="page4"></a><span href="#/cap06" title="Link target outside of Sample">ENERGIZE</span></p>
<p class="toc1"><span href="#/cap06" title="Link target outside of Sample"><em class="italic">Chapter One</em></span></p>
<p class="toc1">Light, refreshing juices, packed with fruits and herbs that energize and kick-start your metabolism</p>
<p class="toc"><span href="#/cap07" title="Link target outside of Sample">FUEL</span></p>
<p class="toc1"><span href="#/cap07" title="Link target outside of Sample"><em class="italic">Chapter Two</em></span></p>
<p class="toc1">Dense, filling, meal-like juices loaded with vitamins, fiber, and healthy fats</p>
<p class="toc"><span href="#/cap08" title="Link target outside of Sample">DETOX</span></p>
<p class="toc1"><span href="#/cap08" title="Link target outside of Sample"><em class="italic">Chapter Three</em></span></p>
<p class="toc1">Detoxifying juices full of naturally cleansing vegetables, fruits, and whole raw spices</p>
<p class="toc"><span href="#/cap09" title="Link target outside of Sample">PROTECT</span></p>
<p class="toc1"><span href="#/cap09" title="Link target outside of Sample"><em class="italic">Chapter Four</em></span></p>
<p class="toc1">Vitamin- and mineral-rich juices that help strengthen your immune system naturally</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?a649acfa